import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Form, Input, Button, Card, message, Modal, Upload, Typography, Space, Select, DatePicker, Tabs, Tooltip, Checkbox, TimePicker, Empty, Row, Col, Divider } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined, PauseOutlined, PlayCircleOutlined, PlusOutlined, SaveOutlined, StopOutlined, UploadOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { adminJobEvent, UpdateJobEVent, allkEventsData, UpdateJobBarocde, getJobsList, reassignSpecJobBarocde, UpdateReWorkEvents, usersCompletedJobEvent, clearUserCompletedData, clearUserJobEventData, clearAdminJobEventData, uploadDataEntryExcel, reworkEventsData } from '../../store/reducer/jobSlice';
import { Link, useNavigate, useParams, useSearchParams, useLocation } from 'react-router-dom';
import PageHeader from "../../view/pageheader";
import * as XLSX from 'xlsx';
import { toast } from 'react-toastify'
import TableComponent from '../CustomComponents/TableComponent';
import Swal from "sweetalert2";
import dayjs from 'dayjs';
import './index.css'
import SearchComponent from '../CustomComponents/SearchComponent';
import moment from 'moment';
const { TabPane } = Tabs;
const JobsEventsAdmin = () => {
    const dispatch = useDispatch();
    const dayjsObject = dayjs();
    const { id } = useParams();
    const location = useLocation();
    const barcode = localStorage.getItem('barcode')
    const [searchParams] = useSearchParams();
    const {
        job_name,
        spec_id,
        // workflow_name,
        job_barcode,

        customer_id,
        // workflow_id
    } = location?.state || {};
    console.log(location?.state, "location==");

    const { jobListData, adminJobEventData, userJobEventData, adminJobEventError, userCompletedData, adminJobEventsDataErrorMessage, jobEventsReworkSuccess, getAllSpecificEventsAssignData, reworkEventsDatas, jobEventUpdateSuccess, jobBarcodeSatusSuccess } = useSelector((state) => state.jobs);
    console.log(adminJobEventData, "adminJobEventData==");

    const [timerValues, setTimerValues] = useState({});
    const jobId = id ? window.atob(id) : null;
    const [selectedSpecId, setSelectedSpecId] = useState(null);
    const { resultData: tableData, totlaCount, eventFieldNames: eventData, eventFieldValidations: validation, nextEventId, previousUserEventId } = adminJobEventData || {};


    const { data: adminEventData } = getAllSpecificEventsAssignData || {}
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [newSpecModel, setNewSpecModel] = useState(false)
    const [markasModal, setMarkasModal] = useState(false)
    const [excelData, setExcelData] = useState(null);
    const userId = Number(localStorage.getItem('user_id'));
    const [form] = Form.useForm();
    const [newForm] = Form.useForm()
    const [fileName, setFileName] = useState(""); // Store file name
    const [originalRows, setOriginalRows] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const navigate = useNavigate()
    const [uploadModalVisible, setUploadModalVisible] = useState(false);
    const [dropdownColumns, setDropdownColumns] = useState({});
    const [uploadMarkAsDatas, setUploadMarkAsDatas] = useState([])
    const [jobData, setJobData] = useState([]);
    const [selectAll, setSelectAll] = useState(false)
    const [activeTab, setActiveTab] = useState("1");
    const [reworkEventData, setReWorkEventData] = useState([])
    const [eventsData, setEventsData] = useState([]);
    const [selectedEventIds, setSelectedEventIds] = useState(null);
    const [eventNames, setEventName] = useState('');
    const [searchValue, setSearchValue] = useState(barcode || job_barcode || "");
    const user_id = localStorage.getItem("user_id");
    const role_id = localStorage.getItem("role_id");
    const [reAssignEventModal, setReAssignEventModal] = useState(false)
    const [selectedEventId, setSelectEventId] = useState(null)
    const { data: reworksEventData } = reworkEventsDatas || {};
    const [currentRecordIndex, setCurrentRecordIndex] = useState(0);
    function getAllData(payload = {}) {
        dispatch(getJobsList(payload))
        dispatch(allkEventsData({ jobId, barcode: job_barcode, role_id, user_id }))
    }
    console.log(rows, "tableData==");
    useEffect(() => {
        if (eventData?.eventFieldNames?.[0]?.event_id) {
            dispatch(reworkEventsData({
                jobId,
                role_id,
                user_id,
                event_id: eventData.eventFieldNames[0].event_id,
                //    workflow_id 
            }));
        }
    }, [eventData]);

    useEffect(() => {
        getAllData({});
    }, [])

    const getData = (payload = {}, tabKey = activeTab) => {
        // Clear query if empty string is passed
        if (payload.query == "") {
            delete payload.query;
        }

        if (tabKey === "1") {
            dispatch(clearAdminJobEventData());
            dispatch(adminJobEvent({ jobId, userId, ...payload }));
        } else if (tabKey === "2") {
            dispatch(clearUserCompletedData());
            dispatch(usersCompletedJobEvent({ jobId, userId, ...payload }));
        }
    };

    useEffect(() => {

        getData()
        if (adminJobEventError) {
            setRows([])
            toast.error(adminJobEventsDataErrorMessage)
            getData()
        }
        if (jobEventsReworkSuccess) {
            dispatch(adminJobEvent({ jobId, userId, event_id: nextEventId, page: 0, limit: 0, query: searchValue, nextClick: true }));
        }
    }, [adminJobEventError, adminJobEventsDataErrorMessage, jobEventsReworkSuccess]);
    useEffect(() => {
        const currentEventId = eventData?.eventFieldNames?.[0]?.event_id || selectedEventIds;

        if (jobEventUpdateSuccess || jobBarcodeSatusSuccess) {
            dispatch(adminJobEvent({
                jobId,
                userId,
                event_id: currentEventId,
                page: 0,
                limit: 0,
                query: searchValue
            }));
        }
    }, [jobEventUpdateSuccess, jobBarcodeSatusSuccess, eventData, selectedEventIds]);
    useEffect(() => {
        if (jobListData?.data) {
            setJobData(jobListData?.data);
        }
        if (adminEventData) {
            setEventsData(adminEventData);
        }
        if (reworksEventData) {
            setReWorkEventData(reworksEventData);

        }
    }, [jobListData, adminEventData, reworksEventData])
    const specIdData = useMemo(() => {
        // if (! !jobData.length) return [];
        return jobData
            .filter((item) => item?.customer_id == window.atob(customer_id)).filter((item) => item?.id != jobId)
            .map((item) => ({
                label: item?.spec_id,
                value: item?.id,
                // workflow_id: item?.workflow_id,
            }));
    }, [jobData]);

    const reworkEventDataGet = useMemo(() => {
        return reworkEventData.map((item) => ({
            label: item?.jobworkflow_event?.eventname ? item?.jobworkflow_event?.eventname : item?.eventname,
            value: item?.jobworkflow_event?.id ? item?.jobworkflow_event?.id : item?.id,
            serial_no: item?.serial_no,
        }));
    }, [reworkEventData]);

    const EventDataGet = useMemo(() => {
        return eventsData.map((item) => ({
            label: item?.jobworkflow_event?.eventname ? item?.jobworkflow_event?.eventname : item?.eventname,
            value: item?.jobworkflow_event?.id ? item?.jobworkflow_event?.id : item?.id,
            serial_no: item?.serial_no,
        }));
    }, [eventsData]);
    const handleDownloadTemplate = () => {
        const filteredRows = rows.filter(row => row.is_moved !== 1 && row.is_completed !== 1)
        if (!filteredRows.length) {
            message.warning("No data available to download.");
            return;
        }

        const dataToDownload = filteredRows;

        // Include all columns except those with undefined dataIndex
        const validColumns = columns.filter(
            (col) =>
                col.dataIndex && !["job_barcode_id", "event_id"].includes(col.dataIndex)
        );

        const headers = validColumns.map((col) => col.title);
        const fieldKeys = validColumns.map((col) => col.dataIndex);

        // Track fields that need special handling
        const dropdownColumns = {};
        const numericFields = new Set();
        const dateFields = new Set(); // Track date fields (fieldtype == 4)

        eventData?.eventFieldNames?.[0]?.event_fields.forEach((field) => {
            if (field.fieldtype == 4) {
                dateFields.add(field.field_name); // Add date fields to the Set
            }


            if (field.fieldtype == 2) {
                numericFields.add(field.field_name);
            }

            if (field.fieldtype == 3) {
                const options =
                    validation?.eventFieldValidations
                        ?.filter((v) => v.field_id == field.field_id)
                        ?.map((data) => data.validationvalue) || [];
                if (options.length) dropdownColumns[field.field_name] = options;
            }
        });

        setDropdownColumns(dropdownColumns);

        // Format data for Template Sheet
        const formattedData = dataToDownload.map((row, index) => {
            let formattedRow = {};
            fieldKeys.forEach((key) => {
                if (key == "box") {
                    formattedRow["Box"] = index + 1;
                } else if (key === "Alt Box") {
                    formattedRow["Alt Box"] = index;
                } else {
                    let value = row[key] !== undefined && row[key] !== null ? row[key] : " ";

                    // Convert to number if field is numeric
                    if (numericFields.has(key)) {
                        value = Number(value) || null;
                    }

                    // Handle date fields (fieldtype == 4)
                    if (dateFields.has(key)) {
                        value = value; // Ensures no special characters or whitespace
                    }

                    formattedRow[key] = value;
                }
            });
            return formattedRow;
        });
        // Create worksheet for Template
        const templateSheet = XLSX.utils.json_to_sheet(formattedData);
        templateSheet["!cols"] = headers.map((header) => ({ wch: header.length + 2 }));

        // Format Dropdown Data Sheet
        const dropdownArray = [];

        // Create worksheet for Dropdown Data
        const dropdownSheet = XLSX.utils.json_to_sheet(dropdownArray);
        dropdownSheet["!cols"] = Object.keys(dropdownColumns).map(() => ({ wch: 20 }));

        // Apply dropdown validation in Template Sheet
        Object.entries(dropdownColumns).forEach(([fieldName, options]) => {
            options.forEach((option, idx) => {
                if (!dropdownArray[idx]) dropdownArray[idx] = {};
                dropdownArray[idx][fieldName] = option;
            });
        });
        // Create workbook and append both sheets
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, templateSheet, "Template");
        if (dropdownArray.length > 0) {
            const dropdownSheet = XLSX.utils.json_to_sheet(dropdownArray);
            dropdownSheet["!cols"] = Object.keys(dropdownColumns).map(() => ({ wch: 20 }));
            XLSX.utils.book_append_sheet(workbook, dropdownSheet, "List Data");
        }
        // Write and download the file
        XLSX.writeFile(workbook, "Template.xlsx");
    };
    const handleMarkAsDownloadTemplate = () => {
        const filteredRows = rows.filter(row => row.is_moved !== 1 && row.is_completed !== 1);
        if (!filteredRows.length) {
            message.warning("No data available to download.");
            return;
        }

        const headers = ["Barcode", "Mark as Completed"];
        const formattedData = filteredRows.map((row) => ({
            // job_barcode_id: row.job_barcode_id || "",
            Barcode: row.barcode || "",
            "Mark as Completed": row.is_completed || "",
        }));

        // Create main template sheet
        const templateSheet = XLSX.utils.json_to_sheet(formattedData);
        templateSheet["!cols"] = headers.map((header) => ({ wch: header.length + 5 }));

        // Create legend sheet
        const legendData = [
            { Values: "0 = Not Completed" },
            { Values: "1 = Completed" },
        ];

        const dropdownSheet = XLSX.utils.json_to_sheet(legendData);
        dropdownSheet["!cols"] = [{ wch: 30 }];

        // Create and save workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, templateSheet, "Template");
        XLSX.utils.book_append_sheet(workbook, dropdownSheet, "Notes");

        XLSX.writeFile(workbook, "Template.xlsx");
    };

    const handleFileChange = ({ file }) => {
        const allowedExtensions = ["xlsx", "xls", "xlsm", "xltx", "ods", "xlsb"];
        const fileExtension = file.name.split(".").pop().toLowerCase();
        if (!allowedExtensions.includes(fileExtension)) {
            toast.error("Invalid file type! Please upload a valid Excel file.");
            return;
        }
        setFileName(file.name);
        const reader = new FileReader();
        reader.onload = (e) => {
            const binaryStr = e.target.result;
            const workbook = XLSX.read(binaryStr, { type: 'binary' });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];

            // Convert sheet data to JSON and ensure empty cells are captured
            let jsonData = XLSX.utils.sheet_to_json(sheet, { raw: false, defval: null });

            // Extract headers from uploaded Excel file
            const excelHeaders = jsonData.length > 0 ? Object.keys(jsonData[0]) : [];

            // Extract expected headers from columns.dataIndex
            const expectedHeaders = columns.map(col => col.dataIndex.toLowerCase());

            // Normalize Excel headers to match dataIndex format
            const normalizedExcelHeaders = excelHeaders.map(header => header.toLowerCase());

            // Check if all expected headers are present in the uploaded file
            const missingHeaders = expectedHeaders.filter(header => !normalizedExcelHeaders.includes(header));
            const extraHeaders = normalizedExcelHeaders.filter(header => !expectedHeaders.includes(header));

            if (missingHeaders.length > 0 || extraHeaders.length > 0) {
                toast.error(`File Header Columns doesn't match`)
                return;
            }

            // Process the data if headers match
            jsonData = jsonData.map((row) => {
                let formattedRow = {};
                const dropdownColumns = {};
                eventData?.eventFieldNames?.[0]?.event_fields.forEach((field) => {
                    if (field.fieldtype === 3) {
                        const options = validation?.eventFieldValidations
                            ?.filter((v) => v.field_id == field.field_id)
                            ?.map((data) => data.validationvalue) || [];
                        if (options.length) dropdownColumns[field.field_name] = options;
                    }
                });


                setDropdownColumns(dropdownColumns);
                Object.keys(row).forEach((key) => {
                    let value = row[key];

                    // Skip date conversion for the "Spec" and "Barcode" columns
                    if (key == "Spec" || key == "Barcode") {
                        formattedRow[key] = value;
                        return;
                    }

                    // Handling Excel serialized date values
                    if (typeof value === "number" && value > 40000 && value < 99999) {
                        // Ensure it's kept as a number instead of a date
                        formattedRow[key] = row[key];
                    }
                    // Handling date formats like DD/MM/YY and converting to DD/MM/YYYY
                    else if (typeof value === "string" && /^\d{2}\/\d{2}\/\d{2}$/.test(value)) {
                        let [day, month, year] = value.split("/");
                        year = parseInt(year, 10) < 50 ? `20${year}` : `19${year}`;
                        formattedRow[key] = `${day}/${month}/${year}`;
                    }
                    // Ensuring numeric values remain as numbers
                    else if (!isNaN(value) && typeof value === "number") {
                        formattedRow[key] = value;
                    } else {
                        formattedRow[key] = value;
                    }
                });


                return formattedRow;
            })
            setExcelData(jsonData); // Store the transformed data
        };

        reader.readAsBinaryString(file);
    };
    useEffect(() => {
        const event = eventData?.eventFieldNames[0]?.event_id;
        if (event) {
            const matchedOption = EventDataGet.find(
                (opt) =>
                    opt.value == event
                // opt.label === event.event_name
            );

            if (matchedOption) {
                setSelectedEventIds(matchedOption.value);
                setEventName(matchedOption.label);
            } else {
                setSelectedEventIds(null);
                setEventName("");
            }
        }
    }, [eventData, EventDataGet]);
    const handleSearchClick = () => {

        console.log(!searchValue.trim(), "haiiiiii==");
        if (!searchValue.trim()) {

            // If search is empty, reset to initial data
            getData({ query: "" }); // Pass empty query to fetch all data
            return;
        }
        const payloadData = {
            query: searchValue,
        };
        dispatch(allkEventsData({ jobId, barcode: searchValue, role_id, user_id }))
        getData(payloadData);
        localStorage.removeItem('barcode');
    };
    useEffect(() => {
        if (barcode || job_barcode) {
            setSearchValue(job_barcode);
            getData({ query: job_barcode });
            // Remove barcode from localStorage after prefill
            localStorage.removeItem('barcode');
        }
    }, [job_barcode]);

    const handleMarkAsFileChange = ({ file }) => {
        const allowedExtensions = ["xlsx", "xls", "xlsm", "xltx", "ods", "xlsb"];
        const fileExtension = file.name.split(".").pop().toLowerCase();

        if (!allowedExtensions.includes(fileExtension)) {
            toast.error("Invalid file type! Please upload a valid Excel file.");
            return;
        }

        setFileName(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const binaryStr = e.target.result;
            const workbook = XLSX.read(binaryStr, { type: 'binary' });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];

            const data = XLSX.utils.sheet_to_json(sheet, { defval: "" });

            // Validate required columns
            const requiredHeaders = ["Barcode", "Mark as Completed"];
            const headersFromSheet = Object.keys(data[0] || {});
            const missingHeaders = requiredHeaders.filter(h =>
                !headersFromSheet.some(header => header.toLowerCase() === h.toLowerCase())
            );

            if (missingHeaders.length) {
                toast.error(`Missing required columns: ${missingHeaders.join(", ")}`);
                return;
            }

            // Get all barcodes marked as completed (1)
            const completedBarcodes = data
                .filter(row => row["Mark as Completed"] == 1)
                .map(row => row["Barcode"]);

            // Find matching job_barcode_ids from the current rows
            const matchingJobBarcodeIds = rows
                .filter(row => completedBarcodes.includes(row.barcode))
                .map(row => row.job_barcode_id);

            setSelectedRowKeys(matchingJobBarcodeIds);
            setUploadMarkAsDatas(matchingJobBarcodeIds);
        };

        reader.readAsBinaryString(file);
    };


    const handleUpload = async () => {
        if (!excelData) {
            message.error('Please select an Excel file to upload');
            return;
        }
        const modifiedRows = getExcelModifiedRows();
        const payload = {
            data: modifiedRows,
            jobId,
            userId,
            event_id: eventData?.eventFieldNames[0]?.event_id
        }
        try {
            dispatch(uploadDataEntryExcel({ postData: payload }))
            setFileName("")
            setIsModalOpen(false);
            setUploadModalVisible(true);
        } catch (error) {
            message.error('File upload failed');
        }
    };
    const markAsCompleteExcelUpload = () => {
        const errors = form.getFieldsError();
        const hasErrors = errors.some(({ errors }) => errors.length > 0);
        if (hasErrors) {
            toast.error("Please correct the errors");
            return;
        }

        // Get the current record (since you're working with single record view)
        const currentRecord = rows[0];
        if (!currentRecord) {
            toast.error("No record found");
            return;
        }

        // Check for mandatory fields
        let hasEmptyRequiredFields = false;
        let missingFields = [];
        const mandatoryFields = eventData?.eventFieldNames?.[0]?.event_fields
            .filter(field => {
                const fieldValidations = validation?.eventFieldValidations?.filter(
                    v => v.field_id == field.field_id && v.mandatory == 1
                );
                return fieldValidations && fieldValidations.length > 0;
            })
            .map(field => field.field_name);

        // Check current record for missing mandatory fields
        for (const fieldName of mandatoryFields) {
            if (!currentRecord[fieldName] && currentRecord[fieldName] !== 0) {
                hasEmptyRequiredFields = true;
                if (!missingFields.includes(fieldName)) {
                    missingFields.push(fieldName);
                }
            }
        }

        if (hasEmptyRequiredFields) {
            const errorMsg = `Required fields missing for barcode ${currentRecord.barcode}: ${missingFields.join(', ')}`;
            message.config({ top: 70 });
            message.error(errorMsg);
            return;
        }

        // Prepare modified data
        const modifiedRows = rows.map((row, index) => {
            const originalRow = originalRows[index] || {};
            const hasChanges = columns.some(column => {
                const fieldName = column.dataIndex;
                return row[fieldName] !== originalRow[fieldName];
            });

            if (!hasChanges) return null;

            return {
                job_barcode_id: row.job_barcode_id,
                barcode: row.barcode,
                spec: row.spec,
                box: row.box,
                alt_box: row.alt_box,
                is_completed: row.is_completed,
                is_moved: row.is_moved,
                is_last_stage: currentRecord.is_last_stage || 0,
                event_id: tableData?.data[0]?.event_id,
                event_name: eventData?.eventFieldNames?.[0]?.event_fields?.[0]?.event_name,
                user_id: Number(localStorage.getItem("user_id")),
                user_name: localStorage.getItem("username"),
                spec_id: window.atob(id),
                event_fields: eventData?.eventFieldNames?.[0]?.event_fields.map(field => ({
                    event_field_id: field.field_id,
                    event_field_name: field.field_name,
                    event_field_value: row[field.field_name] || "",
                    field_type: field.fieldtype
                }))
            };
        }).filter(Boolean);

        const payload = {
            selectedRowKeys: [currentRecord.job_barcode_id], // Only mark current record as complete
            event_id: eventData.eventFieldNames[0].event_id,
            user_id: localStorage.getItem("user_id"),
            spec_id: window.atob(id),
            type: "0",// Not using selectAll in single record view
            barcode: currentRecord.barcode,
            is_last_stage: currentRecord.is_last_stage || 0,
            pre_event_completed: currentRecord.pre_event_completed,
            prev_event: currentRecord.prev_event,

        };

        // Check if this is the last stage
        if (currentRecord.is_last_stage == 1) {
            if (!currentRecord.pre_event_completed) {
                // prev_event is assumed to be an array of event names
                const pendingEvents = currentRecord.prev_event || [];
                const eventList = pendingEvents.length > 0
                    ? `<ul style="text-align: left; margin: 10px 0;">${pendingEvents.map(e => `<li>${e?.event_name}</li>`).join('')}</ul>`
                    : "<p>No specific previous events listed.</p>";

                Swal.fire({
                    title: 'Previous Events Pending',
                    html: `The following previous events are not completed:<br>${eventList}<br>
                   <span style="color: #ff4d4f; font-weight: bold;">
                   This box is in the final stage. Do you still want to complete it?
                   </span>`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, complete anyway',
                    cancelButtonText: 'Cancel',
                    reverseButtons: true,
                    customClass: {
                        popup: 'last-stage-pending-events-popup'
                    }
                }).then((result) => {
                    if (result.isConfirmed) {
                        proceedWithCompletion(modifiedRows, payload, currentRecord);
                    }
                });
            } else {
                // Normal last stage confirmation (if all pre events completed)
                const eventName = eventData?.eventFieldNames?.[0]?.event_fields?.[0]?.event_name || "this event";

                Swal.fire({
                    title: 'Final Stage Completion',
                    html: `The event <strong>${eventName}</strong> is the final stage. Are you sure you want to complete this event?<br><br>
                   <span style="color: #ff4d4f; font-weight: bold;">This action cannot be undone.</span>`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, complete final stage',
                    cancelButtonText: 'Cancel',
                    reverseButtons: true,
                    customClass: {
                        popup: 'last-stage-popup'
                    }
                }).then((result) => {
                    if (result.isConfirmed) {
                        proceedWithCompletion(modifiedRows, payload, currentRecord);
                    }
                });
            }
        } else {
            // Regular non-last stage confirmation
            Swal.fire({
                title: 'Are you sure?',
                text: "Do you want to mark this barcode as completed for this Event Stage?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, mark as completed',
            }).then((result) => {
                if (result.isConfirmed) {
                    proceedWithCompletion(modifiedRows, payload, currentRecord);
                }
            });
        }

    };
    const proceedWithCompletion = (modifiedRows, payload, currentRecord) => {
        // First update any changed fields
        if (modifiedRows.length > 0) {
            dispatch(UpdateJobEVent({ postData: modifiedRows }))
                .then(() => {
                    setOriginalRows([...rows]);
                })
                .catch((error) => {
                    console.error("Update failed:", error);
                });
        }

        // Then mark as complete
        dispatch(UpdateJobBarocde({ postData: payload }))
            .then(() => {
                // Update local state
                setRows(prevRows =>
                    prevRows.map(row =>
                        row.job_barcode_id === currentRecord.job_barcode_id
                            ? { ...row, is_completed: 1 }
                            : row
                    )
                );
                setOriginalRows(prevRows =>
                    prevRows.map(row =>
                        row.job_barcode_id === currentRecord.job_barcode_id
                            ? { ...row, is_completed: 1 }
                            : row
                    )
                );

                setMarkasModal(false);
                setFileName("");
                setSelectedRowKeys([]);

                // Show different success message for last stage
                if (currentRecord.is_last_stage === 1) {
                    toast.success('Final stage completed successfully! This barcode is now fully processed.');
                } else {
                    toast.success('Barcode marked as completed successfully');
                }

                // window.location.reload()
            })
            .catch((error) => {
                console.error("Failed to mark as complete:", error);
                toast.error('Failed to mark barcode as completed');
            });
    };
    const clearEventState = () => {
        setRows([]);
        setOriginalRows([]);
        setSelectedRowKeys([]);
        setCurrentRecordIndex(0);
        form.resetFields(); // Clear form fields
    };

    const handleNextClick = () => {
        if (nextEventId) {
            clearEventState();
            dispatch(adminJobEvent({ jobId, userId, event_id: nextEventId, page: 0, limit: 0, query: searchValue, nextClick: true }));
        } else {
            console.warn("Next Event ID is not available.");
        }
    };

    const handlePreviousClick = () => {
        if (previousUserEventId) {
            clearEventState();
            dispatch(adminJobEvent({ jobId, userId, event_id: previousUserEventId, page: 0, limit: 0, query: searchValue, nextClick: true }));
        } else {
            console.warn("Previous Event ID is not available.");
        }
    }

    const getValidationRules = (validations) => {


        let rules = [];
        if (!validations || validations.length === 0) return rules;

        validations.forEach((validation) => {
            const { validation: type, validationvalue, minvalue, maxvalue, mandatory, fieldtype } = validation;

            if (mandatory == 1) {
                rules.push({
                    required: true,
                    message: "This field is required",
                });
            }

            if (mandatory == 1 && fieldtype == 3) {
                rules.push({
                    required: true,
                    message: "This field is required",
                });
                rules.push({
                    validator: (_, value) => {
                        if (!value) {
                            return Promise.reject(new Error("Field is required"));
                        }
                        return Promise.resolve();
                    },
                });
            }
            switch (type) {

                case 1: // Numeric Length
                    rules.push({
                        validator: (_, value) => {
                            if (!value) {
                                return Promise.resolve(); // Allow empty values (optional)
                            }

                            if (!/^\d+$/.test(value)) {
                                return Promise.reject("Only numbers are allowed!");
                            }

                            const length = value.length;

                            if (length >= parseInt(minvalue) && length <= parseInt(maxvalue)) {
                                return Promise.resolve(); // Validation passed
                            }

                            return Promise.reject(
                                `Length must be between ${minvalue} and ${maxvalue} characters`
                            );
                        },
                    });
                    break;
                case 2: // Decimal
                    rules.push({
                        validator: (_, value) => {
                            if (!value) return Promise.resolve(); // Allow empty values

                            if (!/^\d+(\.\d+)?$/.test(value)) {
                                return Promise.reject("Only numeric values are allowed!");
                            }

                            const regex = new RegExp(`^\\d+(\\.\\d{1,${validationvalue}})?$`);
                            return regex.test(value)
                                ? Promise.resolve()
                                : Promise.reject(`Value must have up to ${validationvalue} decimal places`);
                        },
                    });
                    break;

                case 3: // Greater Than
                    rules.push({
                        validator: (_, value) => {
                            if (!value) return Promise.resolve(); // Allow empty values

                            if (!/^\d+(\.\d+)?$/.test(value)) {
                                return Promise.reject("Only numeric values are allowed!");
                            }

                            return parseFloat(value) > Number(validationvalue)
                                ? Promise.resolve()
                                : Promise.reject(`Value must be greater than ${validationvalue}`);
                        },
                    });
                    break;

                case 4: // Less Than
                    rules.push({
                        validator: (_, value) => {
                            if (!value) return Promise.resolve(); // Allow empty values

                            if (!/^\d+(\.\d+)?$/.test(value)) {
                                return Promise.reject("Only numeric values are allowed!");
                            }

                            return parseFloat(value) < parseFloat(validationvalue)
                                ? Promise.resolve()
                                : Promise.reject(`Value must be less than ${validationvalue}`);
                        },
                    });
                    break;
                case 6: // String Length
                    rules.push({
                        validator: (_, value) => {
                            if (!value) {
                                return Promise.resolve(); // Allow empty values (optional)
                            }

                            const length = value.length;

                            if (length >= parseInt(minvalue) && length <= parseInt(maxvalue)) {
                                return Promise.resolve(); // Validation passed
                            }

                            return Promise.reject(
                                `Length must be between ${minvalue} and ${maxvalue} characters`
                            );
                        },
                    });
                    break;

                case 9: // Alphabetic
                    rules.push({
                        pattern: /^[A-Za-z]+$/,
                        message: "Value must contain only alphabetic characters",
                    });
                    break;

                case 10: // Alphanumeric
                    rules.push({
                        pattern: /^[A-Za-z0-9]+$/,
                        message: "Value must contain only letters and numbers",
                    });
                    break;

                case 11: // Format (Assuming regex format)
                    if (validationvalue == "MM/DD/YYYY") {
                        rules.push({
                            validator: (_, value) => {
                                if (!value) return Promise.resolve();
                                const formattedDate = dayjs(value).format('MM/DD/YYYY');
                                const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/;
                                return regex.test(formattedDate)
                                    ? Promise.resolve()
                                    : Promise.reject(`Value must match the format: ${validationvalue} (e.g., 12/31/2025)`);
                            },
                        });
                    } else if (validationvalue == "DD/MM/YYYY") {
                        rules.push({
                            validator: (_, value) => {
                                if (!value) return Promise.resolve();

                                const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
                                const formattedDate = dayjs(value).format('DD/MM/YYYY');
                                return regex.test(formattedDate)
                                    ? Promise.resolve()
                                    : Promise.reject(`Value must match the format: ${validationvalue} (e.g., 31/12/2025)`);


                            },
                        });
                    } else {
                        rules.push({
                            pattern: new RegExp(validationvalue),
                            message: `Value must match the format: ${validationvalue}`,
                        });
                    }
                    break;


                case 12: // Past Dates Allowed
                    rules.push({
                        validator: (_, value) => {
                            if (!value) return Promise.resolve(); // Allow empty values (optional)

                            const inputDate = new Date(value);
                            const today = new Date();
                            const yesterday = new Date();

                            // Set today's date to midnight
                            today.setHours(0, 0, 0, 0);
                            // Get yesterday's date (normalize time)
                            yesterday.setDate(yesterday.getDate() - 1);
                            yesterday.setHours(0, 0, 0, 0);

                            return inputDate.getTime() <= yesterday.getTime()
                                ? Promise.resolve()
                                : Promise.reject("Only past dates up to yesterday are allowed and Value must match the format:MM/DD/YYYY");
                        },
                    });
                    break;

                case 13: // Time format (HH:MM)
                    if (validationvalue == "hh::mm::ss") {
                        rules.push({
                            validator: (_, value) => {
                                if (!value) return Promise.resolve();
                                const timeString = dayjs(value).format('HH:mm:ss');

                                const regex = /^(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d$/;
                                return regex.test(timeString)
                                    ? Promise.resolve()
                                    : Promise.reject(`Value must match the format: ${validationvalue} (e.g., 02:40:04)`);
                            },
                        });
                    } else if (validationvalue == "hh::mm") {
                        rules.push({
                            validator: (_, value) => {
                                if (!value) return Promise.resolve();

                                const regex = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
                                const timeString = dayjs(value).format('HH:mm');
                                return regex.test(timeString)
                                    ? Promise.resolve()
                                    : Promise.reject(`Value must match the format: ${validationvalue} (e.g., 02:40)`);
                            },
                        });
                    } else {
                        rules.push({
                            pattern: new RegExp(validationvalue),
                            message: `Value must match the format: ${validationvalue} (e.g., 02:40)`,
                        });
                    }
                    break;

                case 14: // Less Than or Equal
                    rules.push({
                        validator: (_, value) => {
                            if (!value) return Promise.resolve(); // Allow empty values

                            if (!/^\d+(\.\d+)?$/.test(value)) {
                                return Promise.reject("Only numeric values are allowed!");
                            }

                            return parseFloat(value) <= parseFloat(validationvalue)
                                ? Promise.resolve()
                                : Promise.reject(`Value must be less than or equal to ${validationvalue}`);
                        },
                    });
                    break;

                case 15: // Greater Than or Equal
                    rules.push({
                        validator: (_, value) => {
                            if (!value) return Promise.resolve(); // Allow empty values

                            if (!/^\d+(\.\d+)?$/.test(value)) {
                                return Promise.reject("Only numeric values are allowed!");
                            }

                            return parseFloat(value) >= parseFloat(validationvalue)
                                ? Promise.resolve()
                                : Promise.reject(`Value must be greater than or equal to ${validationvalue}`);
                        },
                    });
                    break;

                case 16: // Format (Regex)
                    if (validationvalue == "DD/MM/YYYY hh:mm:ss") {
                        rules.push({
                            validator: (_, value) => {
                                if (!value) return Promise.resolve();

                                const regex = /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4} (?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d$/;
                                return regex.test(value)
                                    ? Promise.resolve()
                                    : Promise.reject(
                                        `Value must match the format: ${validationvalue} (e.g., 03/10/2025 02:40:04)`
                                    );
                            },
                        });
                    } else if (validationvalue === "DD/MM/YYYY hh:mm") {
                        rules.push({
                            validator: (_, value) => {
                                if (!value) return Promise.resolve();

                                const regex = /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4} (?:[01]\d|2[0-3]):[0-5]\d$/;
                                return regex.test(value)
                                    ? Promise.resolve()
                                    : Promise.reject(
                                        `Value must match the format: ${validationvalue} (e.g., 03/10/2025 02:40)`
                                    );
                            },
                        });
                    } else if (validationvalue === "MM/DD/YYYY hh:mm:ss") {
                        rules.push({
                            validator: (_, value) => {
                                if (!value) return Promise.resolve();

                                // If Day.js object → format it
                                const formattedValue =
                                    typeof value === "object" && value?.format
                                        ? value.format("MM/DD/YYYY HH:mm:ss")
                                        : value;

                                const regex =
                                    /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4} (?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d$/;

                                return regex.test(formattedValue)
                                    ? Promise.resolve()
                                    : Promise.reject(
                                        `Value must match the format: ${validationvalue} (e.g., 10/03/2025 02:40:04)`
                                    );
                            },
                        });
                    } else {
                        rules.push({
                            validator: (_, value) => {
                                if (!value) return Promise.resolve();

                                // Corrected regex for "MM/DD/YYYY hh:mm"
                                const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4} (?:[01]\d|2[0-3]):[0-5]\d$/;
                                return regex.test(value)
                                    ? Promise.resolve()
                                    : Promise.reject(
                                        `Value must match the format: ${validationvalue} (e.g., 10/03/2025 02:40)`
                                    );
                            },
                        });
                    }
                    break;

                default:
                    break;
            }
        });

        return rules;
    };


    function evaluateDynamicExpression(expression, idToNameMap, nameToValueMap) {
        // Extract numbers (IDs) and operators
        let tokens = expression.match(/(\d+|\+|\-|\*|\/)/g) || [];

        // Replace IDs with their corresponding field names
        let namedExpression = expression
            .split(' ')
            .map(token => {
                const mapped = idToNameMap[token] || token;
                return mapped;
            })
            .join(',');
        // Replace field names with their actual values (default to 0 if undefined)
        let finalExpression = namedExpression
            .split(',')
            .map(token => {
                const value = nameToValueMap[token] || token;
                return value;
            })
            .join(' ');

        // Evaluate the final numeric expression
        try {
            return eval(finalExpression);
        } catch (error) {
            return null;
        }
    }
    function evaluateTimeExpression(expression, idToNameMap, nameToValueMap, filedType) {
        let namedExpression

        // Replace field IDs with their names
        const namedExpression1 = expression
            .split(',')
            .map(token => {
                const mapped = idToNameMap[token] || token;
                return mapped;
            })
            .join(',');
        const namedExpression2 = expression
            .split(' ')
            .map(token => {
                const mapped = idToNameMap[token] || token;
                return mapped;
            })
            .join(',');
        if (filedType == 9) {
            namedExpression = namedExpression1
        } else if (filedType == 10) {
            namedExpression = namedExpression2
        }
        // Replace field names with their values
        const finalExpression = namedExpression
            .split(',')
            .map(token => {
                const value = nameToValueMap[token] || token;
                return value;
            })
            .join(' ');
        // Split into components (e.g., ["12:18:00", "-", "12:10:00"])
        const parts = finalExpression.split(/(\+|\-)/)
            .filter(part => part.trim() !== '')
            .map(part => part.trim());

        let result = null;
        let currentOperator = null;

        for (let i = 0; i < parts.length; i++) {
            const part = parts[i].trim();
            if (part == '+' || part == '-') {
                currentOperator = part;
                continue;
            }
            if (part.match(/^\d{2}:\d{2}:\d{2}$/)) {
                const timeInSeconds = timeToSeconds(part);

                if (result == null) {
                    result = timeInSeconds;
                } else {
                    if (currentOperator === '+') {
                        result += timeInSeconds;
                    } else if (currentOperator === '-') {


                        result -= timeInSeconds;

                    }
                }
            }
        }
        return result;
    }

    // Convert HH:MM:SS to total seconds
    function timeToSeconds(timeStr) {
        const [hours, minutes, seconds] = timeStr.split(':').map(Number);
        return hours * 3600 + minutes * 60 + seconds;
    }

    // Convert seconds back to HH:MM:SS format
    function secondsToTime(totalSeconds) {
        totalSeconds = Math.abs(totalSeconds); // Use absolute value
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        return [
            hours.toString().padStart(2, '0'),
            minutes.toString().padStart(2, '0'),
            seconds.toString().padStart(2, '0')
        ].join(':');
    }

    const rowSelection = activeTab === "1" ? {
        selectedRowKeys,
        onChange: (selectedKeys) => {
            const validKeys = selectedKeys.filter(key => {
                const row = rows.find(r => r.job_barcode_id == key)
                return row && row.is_moved !== 1;
            });
            setSelectedRowKeys(validKeys);
        },
        getCheckboxProps: (record) => ({
            disabled: record.is_moved == 1,
        }),
        renderCell: (checked, record, index, node) => {
            if (record.is_moved == 1) {
                return (
                    <Tooltip title="This barcode is moved to another spec">
                        <span>{node}</span>
                    </Tooltip>
                );
            }
            return node;
        }
    } : null;


    useEffect(() => {
        if (!eventData?.eventFieldNames?.[0]?.event_fields) return;
        const fieldMappings = eventData.eventFieldNames[0].event_fields
            .filter((field) => !["Spec", "Barcode", "Box", "Alt Box"].includes(field.field_name)) // Remove Spec & Barcode
            .map((field) => ({
                title: (
                    <span>

                        {field.field_name}
                        {validation?.eventFieldValidations?.some(
                            v => v.field_id === field.field_id && v.mandatory == 1
                        ) && <span style={{ color: 'red', marginLeft: 4 }}>*</span>}
                    </span>
                ),
                dataIndex: field.field_name, // Use field_name as key
                key: field.field_id,
                render: (_, record, index) => {

                    const fieldValidation = validation?.eventFieldValidations?.filter((v) => v.field_id == field.field_id) || [];


                    // Unique name for Form.Item
                    const fieldPath = (index) => [index, field.field_name];
                    const title = field.field_name
                    const fieldType = field.fieldtype
                    const dropDownOptions =
                        fieldType === 3
                            ? fieldValidation.map((data) => ({ label: data.validationvalue, value: data.validationvalue }))
                            : [];
                    if (fieldType === 6) {
                        // Get all validation values as an array
                        const validationValues = fieldValidation.map((v) => v.validationvalue); // ["16,+,17", "16,+,19"]

                        if (validationValues.length > 0) {
                            const idToNameMap = Object.fromEntries(
                                eventData.eventFieldNames[0].event_fields.map((f) => [f.field_id, f.field_name])
                            );

                            const nameToValueMap = Object.fromEntries(
                                eventData.eventFieldNames[0].event_fields.map((f) => [
                                    f.field_name,
                                    record[f.field_name] || 0, // Default to 0 if no value
                                ])
                            );

                            // Include Spec and Barcode in nameToValueMap
                            nameToValueMap["Spec"] = record["spec"] || 0;
                            nameToValueMap["Barcode"] = record["barcode"] || 0;

                            // Evaluate all expressions and sum the results
                            const totalSum = validationValues
                                .map((expression) => evaluateDynamicExpression(expression, idToNameMap, nameToValueMap))
                                .reduce((sum, value) => sum + value, 0);



                            return <span>{totalSum}</span>;
                        }
                    }
                    // In your columns mapping
                    if (fieldType === 9 || fieldType == 10) {
                        return (
                            <Form.Item name={fieldPath(index)} rules={getValidationRules(fieldValidation)} noStyle>
                                <span>{record[field.field_name]}</span>
                            </Form.Item>
                        );
                    }


                    const dateFormat =
                        fieldValidation.some((v) => v.validationvalue === "MM/DD/YYYY")
                            ? "MM/DD/YYYY"
                            : fieldValidation.some((v) => v.validationvalue === "DD/MM/YYYY")
                                ? "DD/MM/YYYY"
                                : null;
                    const timeFormat = fieldValidation.some((v) => v.validationvalue == "hh::mm::ss")
                        ? "hh:mm:ss"
                        : fieldValidation.some((v) => v.validationvalue == "hh::mm")
                            ? "hh::mm"
                            : null;
                    const dateTimeFormat = fieldValidation.some((v) => v.validationvalue == "DD/MM/YYYY hh:mm:ss")
                        ? "DD/MM/YYYY hh:mm:ss"
                        : fieldValidation.some((v) => v.validationvalue === "DD/MM/YYYY hh:mm")
                            ? "DD/MM/YYYY hh:mm"
                            : fieldValidation.some((v) => v.validationvalue === "MM/DD/YYYY hh:mm:ss")
                                ? "MM/DD/YYYY hh:mm:ss"
                                : fieldValidation.some((v) => v.validationvalue == "MM/DD/YYYY hh:mm ")
                                    ? "MM/DD/YYYY hh:mm" : null;

                    return (
                        <Form.Item name={fieldPath(index)} rules={getValidationRules(fieldValidation)} noStyle>
                            <div>

                                {fieldType == 3 && field.is_station == 1 ?
                                    <Select
                                        options={
                                            Array.isArray(tableData?.stationMasterData)
                                                ? tableData.stationMasterData.map((data) => ({
                                                    label: data.label,  // what user sees
                                                    value: data.value ?? data.label, // what gets stored (fallback to label if no value)
                                                }))
                                                : []}
                                        placeholder="Select Value"
                                        value={record[field?.field_name] || undefined}
                                        onChange={(value) => {
                                            setRows((prevRows) =>
                                                prevRows.map((row, rowIndex) =>
                                                    row.job_barcode_id == record.job_barcode_id ? { ...row, [field.field_name]: value } : row
                                                )
                                            );
                                            form.setFieldsValue({ [fieldPath(index)]: value });
                                        }}
                                    // style={{ width: "300px" }}
                                    />
                                    : fieldType === 3 ? (
                                        <Select
                                            options={dropDownOptions}
                                            placeholder="Select Value"
                                            value={record[field.field_name] || undefined}
                                            onChange={(value) => {
                                                setRows((prevRows) =>
                                                    prevRows.map((row, rowIndex) =>
                                                        row.job_barcode_id == record.job_barcode_id ? { ...row, [field.field_name]: value } : row
                                                    )
                                                );
                                                form.setFieldsValue({ [fieldPath(index)]: value });
                                            }}
                                        // style={{ width: "300px" }}
                                        />
                                    ) : fieldType === 4 && dateFormat ? (
                                        <DatePicker
                                            format={dateFormat}
                                            value={
                                                record[field.field_name]
                                                    ? dayjs(record[field.field_name], dateFormat)
                                                    : null
                                            }
                                            onOpenChange={(open) => {
                                                if (open && !record[field.field_name]) {
                                                    const now = dayjs();
                                                    const dateString = now.format(dateFormat);

                                                    // Update table rows
                                                    setRows((prevRows) =>
                                                        prevRows.map((row, rowIndex) =>
                                                            row.job_barcode_id == record.job_barcode_id
                                                                ? { ...row, [field.field_name]: dateString }
                                                                : row
                                                        )
                                                    );

                                                    // Update form field value
                                                    form.setFieldsValue({
                                                        [fieldPath(index)]: dateString,
                                                    });
                                                }
                                            }}
                                            onChange={(date, dateString) => {
                                                setRows((prevRows) =>
                                                    prevRows.map((row, rowIndex) =>
                                                        row.job_barcode_id == record.job_barcode_id
                                                            ? { ...row, [field.field_name]: dateString }
                                                            : row
                                                    )
                                                );

                                                form.setFieldsValue({
                                                    [fieldPath(index)]: dateString,
                                                });
                                            }}
                                        />

                                    ) :
                                        // fieldType == 5 && field.field_name == "Timer" ? (
                                        //   record[field.field_name] ? (
                                        //     <span>{record[field.field_name]}</span>
                                        //   ) : (
                                        //     <BarcodeTimer
                                        //       key={record.job_barcode_id}
                                        //       onStop={(time) => handleTimerStop(record.job_barcode_id, time)}
                                        //     />
                                        //   )
                                        // ) : 
                                        fieldType == 7 && dateTimeFormat ? (
                                            <DatePicker
                                                showTime // important for time support
                                                format={dateTimeFormat}
                                                value={
                                                    record[field.field_name]
                                                        ? dayjs(record[field.field_name], dateTimeFormat)
                                                        : null
                                                }
                                                onOpenChange={(open) => {
                                                    if (open && !record[field.field_name]) {
                                                        const now = dayjs();
                                                        const dateString = now.format(dateTimeFormat); // use dateTimeFormat here

                                                        // Update table rows
                                                        setRows((prevRows) =>
                                                            prevRows.map((row, rowIndex) =>
                                                                row.job_barcode_id == record.job_barcode_id
                                                                    ? { ...row, [field.field_name]: dateString }
                                                                    : row
                                                            )
                                                        );

                                                        // Update form field value
                                                        form.setFieldsValue({
                                                            [fieldPath(index)]: dateString,
                                                        });
                                                    }
                                                }}
                                                onChange={(date, dateString) => {
                                                    setRows((prevRows) =>
                                                        prevRows.map((row, rowIndex) =>
                                                            row.job_barcode_id == record.job_barcode_id
                                                                ? { ...row, [field.field_name]: dateString }
                                                                : row
                                                        )
                                                    );

                                                    form.setFieldsValue({
                                                        [fieldPath(index)]: dateString,
                                                    });
                                                }}
                                            />
                                        ) : fieldType == 5 && timeFormat ? (
                                            <TimePicker
                                                format={timeFormat}
                                                value={
                                                    record[field.field_name]
                                                        ? dayjs(record[field.field_name], timeFormat)
                                                        : null
                                                }

                                                onOpenChange={(open) => {
                                                    if (open && !record[field.field_name]) {
                                                        const now = dayjs();
                                                        const dateString = now.format(timeFormat);

                                                        // Update table rows
                                                        setRows((prevRows) =>
                                                            prevRows.map((row, rowIndex) =>
                                                                row.job_barcode_id == record.job_barcode_id
                                                                    ? { ...row, [field.field_name]: dateString }
                                                                    : row
                                                            )
                                                        );

                                                        // Update form field
                                                        form.setFieldsValue({
                                                            [fieldPath(index)]: dateString,
                                                        });
                                                    }
                                                }}
                                                onChange={(date, dateString) => {
                                                    setRows((prevRows) =>
                                                        prevRows.map((row, rowIndex) =>
                                                            row.job_barcode_id == record.job_barcode_id
                                                                ? { ...row, [field.field_name]: dateString }
                                                                : row
                                                        )
                                                    );

                                                    form.setFieldsValue({
                                                        [fieldPath(index)]: dateString,
                                                    });
                                                }}
                                            />

                                        ) : fieldType == 8 && timeFormat ? (
                                            <TimePicker
                                                format={timeFormat}
                                                value={
                                                    record[field.field_name]
                                                        ? dayjs(record[field.field_name], timeFormat)
                                                        : null
                                                }
                                                onOpenChange={(open) => {
                                                    if (open && !record[field.field_name]) {
                                                        const now = dayjs();
                                                        const dateString = now.format(timeFormat);

                                                        // Update table rows
                                                        setRows((prevRows) =>
                                                            prevRows.map((row, rowIndex) =>
                                                                row.job_barcode_id == record.job_barcode_id
                                                                    ? { ...row, [field.field_name]: dateString }
                                                                    : row
                                                            )
                                                        );

                                                        // Update form field
                                                        form.setFieldsValue({
                                                            [fieldPath(index)]: dateString,
                                                        });
                                                    }
                                                }}
                                                onChange={(date, dateString) => {
                                                    setRows((prevRows) =>
                                                        prevRows.map((row, rowIndex) =>
                                                            row.job_barcode_id == record.job_barcode_id
                                                                ? { ...row, [field.field_name]: dateString }
                                                                : row
                                                        )
                                                    );

                                                    form.setFieldsValue({
                                                        [fieldPath(index)]: dateString,
                                                    });
                                                }}
                                            />

                                        ) : field.field_name?.trim().toLowerCase() === "station" ? (

                                            <Select
                                                options={tableData?.stationMasterData ? Array.isArray(tableData?.stationMasterData) : []}
                                                placeholder="Select Value"
                                                value={record[field.field_name] || undefined}
                                                onChange={(value) => {
                                                    setRows((prevRows) =>
                                                        prevRows.map((row) =>
                                                            row.job_barcode_id === record.job_barcode_id
                                                                ? { ...row, [field.field_name]: value }
                                                                : row
                                                        )
                                                    );

                                                    form.setFieldsValue({ [fieldPath(index)]: value });
                                                }}
                                                style={{ width: "300px" }}
                                            />
                                        ) : (
                                            <Input
                                                type={["Box", "Alt Box"].includes(field.field_name) ? "number" : "text"}
                                                value={record[field.field_name] || ""}
                                                placeholder="Enter Value"
                                                onChange={(e) => {
                                                    const { value } = e.target;
                                                    setRows((prevRows) =>
                                                        prevRows.map((row) =>
                                                            row.job_barcode_id == record.job_barcode_id
                                                                ? { ...row, [field.field_name]: value }
                                                                : row
                                                        )
                                                    );
                                                }}
                                            />
                                        )}

                                <Form.Item shouldUpdate dependencies={[fieldPath(index)]} noStyle>
                                    {({ getFieldError }) => {
                                        const errors = getFieldError(fieldPath(index));
                                        return errors?.length > 0 ? (
                                            <div style={{ color: "red", fontSize: "12px" }}>{errors.join(", ")}</div>
                                        ) : null;
                                    }}
                                </Form.Item>
                            </div>
                        </Form.Item>
                    );
                },

            }));



        // Include barcode and job_barcode_id in the columns
        const tableColumns = [
            {
                title: "View History",
                key: "history",
                dataIndex: "history",
                render: (_text, record) => (
                    <Button
                        shape="circle"
                        className="border-0"
                        icon={<ArrowRightOutlined />}
                        onClick={() =>
                            navigate(
                                `/view-history/${window.btoa(record?.barcode)}?event_id=${window.btoa(eventData?.eventFieldNames?.[0]?.event_id)}`
                            )
                        }
                    />
                )
            },
            { title: "Spec", dataIndex: "spec", key: "spec" },
            { title: "Barcode", dataIndex: "barcode", key: "barcode", render: (text) => <strong>{text}</strong>, },
            {
                title: "Box",
                dataIndex: "box",
                key: "box",
            },
            {
                title: "Alt Box",
                dataIndex: "alt_box",
                key: "alt_box",
            },
            ...fieldMappings,
        ];




        setColumns(tableColumns);
    }, [eventData, validation]);
    // Update columns when eventData changes
    useEffect(() => {
        if (!rows.length || !eventData?.eventFieldNames?.[0]?.event_fields) return;

        const eventFields = eventData.eventFieldNames[0].event_fields;
        const idToNameMap = Object.fromEntries(eventFields.map(f => [f.field_id, f.field_name]));

        const timeFields = eventFields.filter(field => field.fieldtype === 9 || field.fieldtype === 10);
        const calcFields = eventFields.filter(field => field.fieldtype === 6);

        const updatedRows = rows.map(row => {
            let updatedRow = { ...row };
            let hasChanged = false;

            // Normalize record keys
            const normalizedRecord = Object.fromEntries(
                Object.entries(row).map(([key, value]) => [key.trim(), value])
            );

            // Create name to value map
            const nameToValueMap = {};
            eventFields.forEach(f => {
                const key = f.field_name.trim();
                let value = normalizedRecord[key];
                if (value === undefined || value === null || value === "") {
                    value = (f.fieldtype === 9 || f.fieldtype === 10) ? "00:00:00" : 0;
                }
                nameToValueMap[key] = value;
            });

            nameToValueMap["Spec"] = normalizedRecord["spec"] ?? "00:00:00";
            nameToValueMap["Barcode"] = normalizedRecord["barcode"] ?? "00:00:00";

            // Handle time fields
            timeFields.forEach(field => {
                const fieldValidation = validation?.eventFieldValidations?.filter(
                    v => v.field_id === field.field_id
                ) || [];

                const validationValues = fieldValidation.map(v => v.validationvalue);
                if (validationValues.length > 0) {
                    const totalTime = validationValues
                        .map(expression => evaluateTimeExpression(expression, idToNameMap, nameToValueMap, field.fieldtype))
                        .reduce((sum, value) => sum + (value || 0), 0);

                    const formatted = secondsToTime(totalTime);
                    if (row[field.field_name] !== formatted) {
                        updatedRow[field.field_name] = formatted;
                        hasChanged = true;
                    }
                }
            });

            // Handle calculated fields
            calcFields.forEach(field => {
                const fieldValidation = validation?.eventFieldValidations?.filter(
                    v => v.field_id === field.field_id
                ) || [];

                const validationValues = fieldValidation.map(v => v.validationvalue);
                if (validationValues.length > 0) {
                    const total = validationValues
                        .map(expression => evaluateDynamicExpression(expression, idToNameMap, nameToValueMap))
                        .reduce((sum, value) => sum + (value || 0), 0);

                    if (row[field.field_name] !== total) {
                        updatedRow[field.field_name] = total;
                        hasChanged = true;
                    }
                }
            });

            return hasChanged ? updatedRow : row;
        });

        const hasAnyChanges = updatedRows.some((row, idx) =>
            JSON.stringify(row) !== JSON.stringify(rows[idx])
        );

        if (hasAnyChanges) {
            setRows(updatedRows);
        }
    }, [rows, eventData, validation]);

    useEffect(() => {
        if (tableData && tableData?.data) {
            // Transform datas to match column structure
            const formattedData = tableData && tableData?.data.map((row, index) => {
                const formattedRow = {
                    job_barcode_id: row.job_barcode_id,
                    barcode: row.barcode,
                    spec: row.spec,
                    box: row?.box,
                    alt_box: row?.alt_box,
                    is_completed: row?.is_completed,
                    is_moved: row?.is_moved,
                    preprocess_id: row?.preprocess_id,
                    is_last_stage: row?.is_last_stage,
                    pre_event_completed: row.pre_event_completed,
                    prev_event: row.prev_event,


                };

                // Map event field values into correct columns
                row.event_fields.forEach((field) => {
                    formattedRow[field.event_field_name] = field.event_field_value;
                });

                return formattedRow;
            });
            setRows(formattedData);
            setOriginalRows(formattedData);
            const completedKeys = formattedData
                .filter((row) => row.is_completed == 1)
                .map((row) => row.job_barcode_id);
            setSelectedRowKeys(rows[0]?.job_barcode_id);
        }
    }, [tableData])
    const getExcelModifiedRows = () => {
        if (!excelData || !eventData?.eventFieldNames?.[0]?.event_fields) return [];

        return excelData.map((excelRow) => {
            // Convert Excel row field names to match your originalRows structure
            const excelBarcode = excelRow.barcode || excelRow.Barcode;
            const excelSpec = excelRow.spec || excelRow.Spec;

            // Find the matching original row by both barcode AND spec for precise matching
            const matchingRow = originalRows.find(row =>
                String(row.barcode) === String(excelBarcode) &&
                String(row.spec) === String(excelSpec)
            );

            if (!matchingRow) {
                // console.error(`No matching row found for Barcode: ${excelBarcode}, Spec: ${excelSpec}`);
                return null; // Skip this row if no match found
            }

            // Get the correct job_barcode_id from the matched original row
            const job_barcode_id = matchingRow.job_barcode_id;

            // Prepare updated fields with proper field name mapping
            const updatedFields = {
                Barcode: excelBarcode,
                Spec: excelSpec,
                Box: excelRow.Box || null
            };

            // Add other fields from columns
            columns.forEach((column) => {
                const fieldName = column.dataIndex;
                // Skip fields we've already handled
                if (['barcode', 'spec', 'Box'].includes(fieldName)) return;

                const excelFieldName = fieldName === 'spec' ? 'Spec' :
                    fieldName === 'barcode' ? 'Barcode' :
                        fieldName;

                if (excelRow[excelFieldName] !== undefined) {
                    updatedFields[fieldName] = excelRow[excelFieldName];
                }
            });

            return {
                job_barcode_id, // Unique for each matched row
                event_id: eventData.eventFieldNames[0].event_id,
                updated_fields: updatedFields
            };
        }).filter(Boolean); // Remove any null entries from unmatched rows
    };

    const renderFormField = (field, record, index) => {
        const is_external = field.is_external
        const isMoved = record.is_moved == 1;
        const is_completed = record.is_completed == 1;
        const fieldValidation = validation?.eventFieldValidations?.filter((v) => v.field_id == field.field_id) || [];
        const fieldType = field.fieldtype;
        const dropDownOptions = fieldType === 3
            ? fieldValidation.map((data) => ({ label: data.validationvalue, value: data.validationvalue }))
            : [];

        const dateFormat = fieldValidation.some((v) => v.validationvalue === "MM/DD/YYYY")
            ? "MM/DD/YYYY"
            : fieldValidation.some((v) => v.validationvalue === "DD/MM/YYYY")
                ? "DD/MM/YYYY"
                : null;

        const timeFormat = fieldValidation.some((v) => v.validationvalue == "hh::mm::ss")
            ? "hh:mm:ss"
            : fieldValidation.some((v) => v.validationvalue == "hh::mm")
                ? "hh::mm"
                : null;

        const dateTimeFormat = fieldValidation.some((v) => v.validationvalue == "DD/MM/YYYY hh:mm:ss")
            ? "DD/MM/YYYY hh:mm:ss"
            : fieldValidation.some((v) => v.validationvalue === "DD/MM/YYYY hh:mm")
                ? "DD/MM/YYYY hh:mm"
                : fieldValidation.some((v) => v.validationvalue === "MM/DD/YYYY hh:mm:ss")
                    ? "MM/DD/YYYY hh:mm:ss"
                    : fieldValidation.some((v) => v.validationvalue == "MM/DD/YYYY hh:mm ")
                        ? "MM/DD/YYYY hh:mm"
                        : null;

        const fieldPath = [index, field.field_name];
        const existingValue = record[field.field_name];
        switch (fieldType) {


            case 3: // Dropdown
                return (
                    <Form.Item
                        name={fieldPath}
                        label={field.field_name}
                        rules={isMoved ? [] : getValidationRules(fieldValidation)}
                    >
                        <Select
                            options={
                                field.is_station == 1
                                    ? Array.isArray(tableData?.stationMasterData)
                                        ? tableData.stationMasterData.map((data) => ({
                                            label: data.label,
                                            value: data.label, // or data.value if you have it
                                        }))
                                        : []
                                    : dropDownOptions
                            }
                            placeholder="Select Value"
                            defaultValue={record[field.field_name]}
                            onChange={(value) => {
                                if (!isMoved) {
                                    setRows((prevRows) =>
                                        prevRows.map((row, rowIndex) =>
                                            row.job_barcode_id == record.job_barcode_id
                                                ? { ...row, [field.field_name]: value }
                                                : row
                                        )
                                    );
                                }
                            }}
                            disabled={isMoved || is_completed || is_external}

                        />
                    </Form.Item>
                );

            case 4: // Date
                return (
                    <Form.Item
                        name={fieldPath}
                        label={field.field_name}
                        rules={getValidationRules(fieldValidation)}
                    >
                        <DatePicker
                            format={dateFormat}
                            style={{ width: '100%' }}
                            defaultValue={record[field.field_name] ? dayjs(record[field.field_name]) : null}
                            onChange={(date, dateString) => {


                                setRows(prevRows =>
                                    prevRows.map(row =>
                                        row.job_barcode_id == record.job_barcode_id
                                            ? { ...row, [field.field_name]: dateString }
                                            : row
                                    )
                                );
                            }}
                            disabled={isMoved || is_completed || is_external}

                        />
                    </Form.Item>
                );

            case 5: // Time
                return (
                    <Col style={{ width: '500px' }}>
                        <Form.Item
                            label={field.field_name}
                            rules={getValidationRules(fieldValidation)}
                        >
                            <TimePicker style={{ width: '430px' }}
                                format={timeFormat}
                                value={
                                    record[field.field_name]
                                        ? dayjs(record[field.field_name], "HH:mm:ss")
                                        : null
                                }
                                onChange={(time, timeString) => {
                                    setRows(prevRows =>
                                        prevRows.map(row =>
                                            row.job_barcode_id === record.job_barcode_id
                                                ? { ...row, [field.field_name]: timeString }
                                                : row
                                        )
                                    );
                                }}
                                disabled={isMoved || is_completed || is_external}
                            />
                        </Form.Item>
                    </Col>

                );

            case 7: // DateTime
                return (
                    <Col style={{ width: '500px' }}>
                        <Form.Item
                            name={fieldPath}
                            label={field.field_name}
                            rules={getValidationRules(fieldValidation)}
                        >
                            <DatePicker
                                showTime
                                format={dateTimeFormat}
                                style={{ width: '100%' }}
                                value={record[field.field_name] ? dayjs(record[field.field_name], dateTimeFormat) : null}
                                onChange={(date, dateString) => {
                                    setRows(prevRows =>
                                        prevRows.map(row =>
                                            row.job_barcode_id === record.job_barcode_id
                                                ? { ...row, [field.field_name]: dateString }
                                                : row
                                        )
                                    );
                                }}
                                disabled={isMoved || is_completed || is_external}
                            />
                        </Form.Item>
                    </Col>
                );
            case 9: // Read-only or label field
            case 10:
                return (
                    <Col style={{ width: '500px' }}>
                        <Form.Item
                            name={fieldPath}
                            label={field.field_name}
                            rules={getValidationRules(fieldValidation)}
                        >
                            <span>{record[field.field_name] ?? "-"}</span>
                        </Form.Item>
                    </Col>
                );

            default: // Text/Number
                return (
                    <Col style={{ width: '500px' }}>
                        <Form.Item
                            name={fieldPath}
                            label={field.field_name}
                            rules={getValidationRules(fieldValidation)}
                        >

                            <Input
                                type={["Box", "Alt Box"].includes(field.field_name) ? "number" : "text"}
                                placeholder="Enter Value"
                                defaultValue={record[field.field_name] || ''}
                                onChange={(e) => {
                                    setRows(prevRows =>
                                        prevRows.map(row =>
                                            row.job_barcode_id === record.job_barcode_id
                                                ? { ...row, [field.field_name]: e.target.value }
                                                : row
                                        )
                                    );
                                }}
                                disabled={isMoved || is_completed || is_external}
                            />

                        </Form.Item>
                    </Col>
                );
        }
    };

    const handleSave = () => {


        const errors = form.getFieldsError();
        const hasErrors = errors.some(({ errors }) => errors.length > 0);
        if (hasErrors) {
            toast.error("Please correct the errors");
            return;
        }

        const modifiedRows = rows.map((row, index) => {
            const originalRow = originalRows[index] || {};

            // Check if any field has changed
            const hasChanges = columns.some(column => {
                const fieldName = column.dataIndex;
                return row[fieldName] !== originalRow[fieldName];
            });

            if (!hasChanges) return null;

            // Prepare the full row data to send
            const rowData = {
                job_barcode_id: row.job_barcode_id,
                barcode: row.barcode,
                spec: row.spec,
                box: row.box,
                alt_box: row.alt_box,
                is_completed: row.is_completed,
                is_last_stage: row.is_last_stage,
                is_moved: row.is_moved,
                event_id: tableData?.data[0]?.event_id,
                event_name: eventData?.eventFieldNames?.[0]?.event_fields?.[0]?.event_name,
                user_id: Number(localStorage.getItem("user_id")),
                user_name: localStorage.getItem("username"),
                spec_id: window.atob(id),

                // Include all event fields
                event_fields: eventData?.eventFieldNames?.[0]?.event_fields.map(field => ({
                    event_field_id: field.field_id,
                    event_field_name: field.field_name,
                    event_field_value: row[field.field_name] || "",
                    field_type: field.fieldtype
                }))
            };

            return rowData;
        }).filter(Boolean);
        if (modifiedRows.length > 0) {
            dispatch(UpdateJobEVent({ postData: modifiedRows }))
                .then(() => {
                    toast.success('Job Event updated successfully');
                    setOriginalRows([...rows]);
                    getData({})
                })
                .catch((error) => {
                    console.error("Update failed:", error);
                    toast.error('Failed to update job event');
                });
        } else {
            toast.info('No changes to save');
        }


        const payload = {
            selectedRowKeys,
            event_id: eventData?.eventFieldNames[0]?.event_id,
            user_name: localStorage.getItem("username"),
            user_id: localStorage.getItem("user_id"),
            spec_id: window.atob(id),
        };
        dispatch(UpdateJobBarocde({ postData: payload }))
            .then(() => {
                // Update local state if needed
            })
            .catch((error) => {
                console.error("Mark as complete failed:", error);
            });
        // if (selectedRowKeys.length > 0) {

        // }
    };
    const handleReassignSpec = () => {
        if (!selectedSpecId) {
            return toast.error("Please select a Spec ID");
        }
        // if (!selectAll) {
        //     if (selectedRowKeys.length == 0) {
        //         return toast.error("Please select one Barcode");
        //     }
        // }


        const payload = {
            barcode_id: rows[0]?.job_barcode_id,
            barcode: rows[0]?.barcode,
            workflow_id: selectedSpecId.workflow_id,
            spec_id: selectedSpecId.value,
            spec: selectedSpecId.label,
            event_id: eventData.eventFieldNames[0].event_id,
            user_id: userId,
            type: selectAll ? "all" : "0"
        };
        Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to reassign the selected barcodes to the new spec?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, reassign',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(reassignSpecJobBarocde({ postData: payload }))
                    .then(() => {
                        // Update the local state to reflect the changes
                        setRows(prevRows =>
                            prevRows.map(row => ({
                                ...row,
                                is_moved: 0 // Reset completion status
                            }))
                        );

                        setOriginalRows(prevRows =>
                            prevRows.map(row => ({
                                ...row,
                                is_moved: 0 // Reset completion status
                            }))
                        );

                        // Clear the selection
                        setSelectedRowKeys([]);
                        setSelectAll(false);

                        toast.success("Event has been reset for re-work successfully");
                        return navigate(-1)
                        // dispatch(adminJobEvent({ jobId, userId }));
                    })
                    .catch((error) => {
                        console.error("Re-work failed:", error);
                        toast.error("Failed to reset event for re-work");
                    });
            }
        });
    };
    useEffect(() => {
        if (rows[currentRecordIndex]) {
            const formValues = {};
            for (const key in rows[currentRecordIndex]) {
                if (!rows[currentRecordIndex][key]) continue;

                const field = eventData?.eventFieldNames?.[0]?.event_fields?.find(f => f.field_name == key);
                const validations = validation?.eventFieldValidations?.filter(v => v.field_id == field?.field_id) || [];

                const isDate = validations?.some(v => v?.validationvalue?.includes("YYYY"));
                const isTime = validations.some(v => v?.validationvalue?.includes('hh::mm::ss'));
                if (isDate || isTime) {
                    const fieldFormat = validations[0]?.validationvalue;
                    formValues[key] = dayjs(rows[currentRecordIndex][key], fieldFormat);
                } else {
                    formValues[key] = rows[currentRecordIndex][key];
                }
            }

            form.setFieldsValue(formValues);
        }
    }, [rows, currentRecordIndex, eventData]);

    // const allBarcodeIds = rows.filter(data => data?.is_moved == 0).map(row => row?.job_barcode_id);
    // const handleSelectAllBarcodes = () => {
    //   const allBarcodeIds = rows.filter(data => data.is_moved == 0).map(row => row.job_barcode_id);
    //   if (allBarcodeIds.length == selectedRowKeys.length) {
    //     return setSelectedRowKeys([])
    //   }
    //   Swal.fire({
    //     title: 'Select All Barcodes?',
    //     text: 'Do you want to select all barcodes?',
    //     icon: 'question',
    //     showCancelButton: true,
    //     confirmButtonText: 'Yes, select all',
    //     cancelButtonText: 'Cancel',
    //     confirmButtonColor: '#3085d6',
    //     cancelButtonColor: '#d33',
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       setSelectAll(true)

    //       // Assuming `rows` is your current data
    //       setSelectedRowKeys(allBarcodeIds);
    //       if (allBarcodeIds.length > 0) {
    //         // toast.success("All barcodes selected");
    //       } else {
    //         toast.error("No barcodes")
    //       }

    //     }
    //   });
    // };

    const handleReworkEvents = () => {
        const payload = {
            selectedRowKeys,
            event_id: eventData.eventFieldNames[0].event_id,
            user_id: localStorage.getItem("user_id"),
            spec_id: window.atob(id),
            type: selectAll ? "all" : "0",
            workflow_id: selectedEventId.workflow_id,
            select_event_serial_no: selectedEventId.serial_no,
            current_event_serial_no: eventData?.eventFieldNames?.[0]?.event_fields?.[0]?.event_serial_no,
            selected_event_id: selectedEventId.value,
            selected_event_serial_no: selectedEventId.serial_no,
            barcodes: rows[0]?.barcode,
            role_id: localStorage.getItem("role_id"),
        };

        Swal.fire({
            title: 'Re-work the Event?',
            text: 'Do you want to re-work  the barcodes in this event?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Yes, re-work ',
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(UpdateReWorkEvents({ postData: payload }))
                    .then(() => {
                        // Update the local state to reflect the changes
                        setRows(prevRows =>
                            prevRows.map(row => ({
                                ...row,
                                is_completed: 0 // Reset completion status
                            }))
                        );

                        setOriginalRows(prevRows =>
                            prevRows.map(row => ({
                                ...row,
                                is_completed: 0 // Reset completion status
                            }))
                        );

                        // Clear the selection
                        setSelectedRowKeys([]);
                        setSelectAll(false);
                        toast.success("Event has been reset for re-work successfully");
                        return navigate(-1)
                    })
                    .catch((error) => {
                        console.error("Re-work failed:", error);
                        toast.error("Failed to reset event for re-work");
                    });
            }
        });
    };


    const handleCancel = () => {
        setSelectedSpecId(null)
        setNewSpecModel(false)
    }
    // Update the handleTabChange function to properly handle tab switching


    // Update the useEffect for data fetching to handle activeTab
    useEffect(() => {
        if (activeTab === "1") {


            // Update rows when in "Pending Barcodes" tab
            if (userJobEventData?.resultData?.data) {
                const formattedData = userJobEventData.resultData.data.map((row) => {
                    const formattedRow = {
                        job_barcode_id: row.job_barcode_id,
                        barcode: row.barcode,
                        spec: row.spec,
                        box: row.box,
                        alt_box: row.alt_box,
                        is_completed: row.is_completed,
                        is_moved: row.is_moved,
                    };

                    row.event_fields.forEach((field) => {
                        formattedRow[field.event_field_name] = field.event_field_value;
                    });

                    return formattedRow;
                });

                setRows(formattedData);
            }
        } else if (activeTab === "2") {
            // Update rows when in "Completed Barcodes" tab
            if (userCompletedData?.resultData?.data) {
                const formattedData = userCompletedData.resultData.data.map((row) => {
                    const formattedRow = {
                        job_barcode_id: row.job_barcode_id,
                        barcode: row.barcode,
                        spec: row.spec,
                        box: row.box,
                        alt_box: row.alt_box,
                        is_completed: row.is_completed,
                        is_moved: row.is_moved,
                    };

                    row.event_fields.forEach((field) => {
                        formattedRow[field.event_field_name] = field.event_field_value;
                    });

                    return formattedRow;
                });

                setRows(formattedData);
            }
        }
    }, [activeTab, userJobEventData, userCompletedData]); // Re-run when activeTab or data changes

    const handleChangeEvent = (value) => {
        clearEventState();
        // dispatch(adminJobEventDetails({ jobId, event_id: value, workflow_id: window.atob(workflow_id) }));
        dispatch(adminJobEvent({ jobId, userId, event_id: value, page: 0, limit: 0, query: searchValue, nextClick: true }));
    }
    const eventName = eventData?.eventFieldNames?.[0]?.event_fields?.[0]?.event_name || "NA";


    // const eventSerail = eventData?.eventFieldNames?.[0]?.event_fields?.[0]?.event_serial_no || "NA";
    const handleRemoveFunction = () => {
        setRows([]);
        setSearchValue('')
        dispatch(clearAdminJobEventData());


    }

    return (
        <div>
            <PageHeader onBack={handleRemoveFunction}
                HeaderText={
                    <>

                        {rows?.length > 0 ? `${eventName} USER Entry Page` : ''}

                    </>
                }
                Breadcrumb={[{ name: 'Jobs' }]}
                backgroundUrlName={true}
            />
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '5px', fontWeight: 800 }}>
                <>



                    {rows.length > 0 && searchValue.trim() !== "" ? (
                        <>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginLeft: '100px',
                                    marginTop: '10px'
                                }}
                            >
                                <Space size={"large"}>
                                    <SearchComponent
                                        style={{ width: '500px' }}
                                        placeHolder="Search Box Number"
                                        value={searchValue}
                                        onChange={e => {
                                            const val = e.target.value;
                                            setSearchValue(val);
                                            if (!val.trim()) {
                                                getData({});
                                            }
                                        }}
                                        onPressEnter={handleSearchClick}
                                    />
                                    <Button className='primary-btn rounded-4' onClick={handleSearchClick}>
                                        Search Box Number
                                    </Button>
                                </Space>
                            </div>
                            <Card style={{ width: "1000px", padding: "10px" }}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "16px",
                                        flexWrap: "wrap", // will wrap on smaller screens
                                    }}
                                >
                                    {/* Select Event Stage */}
                                    <span style={{ fontWeight: 600 }}>Selected Event Stages:</span>
                                    <Select
                                        placeholder="Select Event Stages"
                                        style={{ width: 250 }}
                                        options={EventDataGet}
                                        value={selectedEventIds}
                                        onChange={(value, option) => {
                                            setSelectedEventIds(value);
                                            setEventName(option.label); // store event name separately if needed
                                            handleChangeEvent(value);
                                        }}
                                    />

                                    {/* Action Buttons */}
                                    <Button
                                        className="btn btn-secondary text-white"
                                        shape="round"
                                        type="primary"
                                        onClick={() => {
                                            message.destroy();
                                            setNewSpecModel(true);
                                        }}
                                        disabled={rows[0]?.is_moved == 1 || rows[0]?.is_completed == 1}
                                    >
                                        Re Assign Spec
                                    </Button>

                                    <Button
                                        className="btn btn-danger"
                                        shape="round"
                                        type="primary"
                                        onClick={() => {
                                            message.destroy("TOAST_KEY");
                                            setReAssignEventModal(true);
                                        }}
                                        disabled={rows[0]?.is_moved == 1 || rows[0]?.is_completed == 1}
                                    >
                                        Re Work Events
                                    </Button>

                                    <Button
                                        className="btn btn-success rounded-4"
                                        icon={<ArrowRightOutlined />}
                                        onClick={() =>
                                            navigate(`/view-event-stages-history/${window.btoa(rows[0].barcode)}`)
                                        }
                                    >
                                        &nbsp; View Box Event History
                                    </Button>
                                </div>
                            </Card>


                        </>
                    ) : (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginRight: '200px',
                            }}
                        >
                            <Space size={"large"}>
                                <SearchComponent
                                    style={{ width: '500px', marginLeft: '100px' }}
                                    placeHolder="Search Box Number"
                                    value={searchValue}
                                    onChange={e => {
                                        const val = e.target.value;
                                        setSearchValue(val);
                                        if (!val.trim()) {
                                            getData({});
                                        }
                                    }}
                                    onPressEnter={handleSearchClick}
                                />
                                <Button className='primary-btn rounded-4' onClick={handleSearchClick}>
                                    Search Box Number
                                </Button>
                            </Space>
                        </div>
                    )}
                </>
            </div>
            <Card >
                {rows.length > 0 && searchValue.trim() !== "" ? (
                    <div>

                        <Card bordered={false}>
                            <div >
                                <div style={{ padding: '5px', marginTop: '-40px', marginLeft: '-30px' }}><strong>BOX NUMBER: </strong>{rows[0]?.barcode}</div>
                                <div style={{ padding: '5px', marginLeft: '-30px' }}><strong>PROJECT NAME : </strong>{window.atob(job_name)}</div>
                                <div style={{ padding: '5px', marginLeft: '-30px' }}><strong>CURRENT BOX STATE :</strong> {tableData?.box_state?.box_state}</div>
                                <div style={{ padding: '5px', marginLeft: '-30px' }}><strong>LATEST RECORDED EVENT STAGE : </strong>{tableData?.last_record_event} </div>
                                {rows[0]?.is_completed ? <div style={{ color: 'green' }}>This Barcode is completed</div> : ''}
                                {rows[0]?.is_moved ? <div style={{ color: 'red' }}>This Barcode is moved to another Spec</div> : ''}
                            </div>
                            <Divider />
                            <Form style={{ marginTop: '10px' }}
                                form={form}
                                layout="vertical"
                                initialValues={rows[currentRecordIndex]}
                                key={rows[currentRecordIndex]?.job_barcode_id} // Force re-render when record changes
                            >
                                <Row gutter={16}>
                                    {/* <Col span={12}>
                                        <Form.Item label="Spec" name="spec">
                                            <Input disabled />
                                        </Form.Item>
                                    </Col> */}
                                    {/* <Col span={12}>
                                        <Form.Item label="Barcode" name="barcode">
                                            <Input disabled />
                                        </Form.Item>
                                    </Col> */}
                                    {/* <Col span={12}>
                                        <Form.Item label="Box" name="box">
                                            <Input disabled />
                                        </Form.Item>
                                    </Col> */}
                                    {/* <Col span={12}>
                                        <Form.Item label="Alt Box" name="alt_box">
                                            <Input disabled />
                                        </Form.Item>
                                    </Col> */}
                                </Row>
                                {eventData?.eventFieldNames?.[0]?.event_fields
                                    .filter(field => !["Spec", "Barcode", "Box", "Alt Box"].includes(field.field_name))
                                    .reduce((rows, field, index) => {
                                        // Group fields in pairs
                                        if (index % 2 === 0) {
                                            rows.push([field]);
                                        } else {
                                            rows[rows.length - 1].push(field);
                                        }
                                        return rows;
                                    }, [])

                                    .map((fieldPair, rowIndex) => (
                                        <Row gutter={16} key={`row-${rowIndex}`}>
                                            {fieldPair.map((field) => (
                                                <Col span={12} key={field.field_id}>
                                                    {renderFormField(field, rows[currentRecordIndex], currentRecordIndex)}
                                                </Col>
                                            ))}
                                            {/* Add empty column if odd number of fields */}
                                            {fieldPair.length == 1 && <Col span={12}></Col>}
                                        </Row>
                                    ))}
                            </Form>
                        </Card>

                        <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between' }}>
                            <div>
                                <Button
                                    onClick={handlePreviousClick}
                                    disabled={previousUserEventId == null}
                                    className='primary-btn rounded-4'
                                >
                                    <ArrowLeftOutlined /> Prev Event
                                </Button>
                                <Button
                                    onClick={handleNextClick}
                                    disabled={nextEventId == null}
                                    style={{ marginLeft: "10px" }}
                                    className='primary-btn rounded-4'
                                >
                                    Next Event <ArrowRightOutlined />
                                </Button>
                            </div>

                            <div>
                                <Button
                                    className="primary-btn mr-3 mt-2"
                                    shape="round"
                                    type="primary"
                                    onClick={() => { markAsCompleteExcelUpload() }}
                                    disabled={rows[0]?.is_moved == 1 || rows[0]?.is_completed == 1}
                                >
                                    <i class="fa fa-check-square" aria-hidden="true"></i>
                                    Mark as Completed
                                </Button>
                                <Button style={{ backgroundColor: 'green', color: 'white' }} disabled={rows[0]?.is_moved == 1 || rows[0]?.is_completed == 1} className=" mt-2" shape="round" type="default" icon={<SaveOutlined />} onClick={handleSave}>
                                    Save & Record Event
                                </Button>

                            </div>
                        </div>
                    </div>
                ) : (
                    <Empty description="No Data Available" />
                )}
            </Card>
            {/* upload excel */}
            <Modal
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={null}
                centered
            // title="Upload Excel"
            >
                <Tabs defaultActiveKey="1">
                    <TabPane tab="Upload Excel" key="1">
                        <Card bordered={false} style={{ textAlign: "center", padding: 20 }}>
                            <Upload
                                beforeUpload={() => false}
                                onChange={handleFileChange}
                                accept=".xlsx, .xls"
                                showUploadList={false}
                            >
                                <Button icon={<UploadOutlined />}>Select File</Button>
                            </Upload>
                            {fileName && (
                                <Typography.Text
                                    type="secondary"
                                    style={{ display: "block", marginTop: 10 }}
                                >
                                    Selected File: {fileName}
                                </Typography.Text>
                            )}
                            <Space direction="vertical" style={{ width: "100%", marginTop: 20 }}>
                                <Button onClick={handleDownloadTemplate} type="default" block>
                                    Download Template
                                </Button>
                                <Button
                                    className="primary-btn"
                                    type="primary"
                                    onClick={handleUpload}
                                    block
                                >
                                    Submit
                                </Button>
                            </Space>
                        </Card>
                    </TabPane>

                    <TabPane tab="Mark As Complete" key="2">
                        <Card bordered={false} style={{ textAlign: "center", padding: 20 }}>
                            <Upload
                                beforeUpload={() => false}
                                onChange={handleMarkAsFileChange}
                                accept=".xlsx, .xls"
                                showUploadList={false}
                            >
                                <Button icon={<UploadOutlined />}>Select File</Button>
                            </Upload>
                            {fileName && (
                                <Typography.Text type="secondary" style={{ display: "block", marginTop: 10 }}>
                                    Selected File: {fileName}
                                </Typography.Text>
                            )}
                            <Space direction="vertical" style={{ width: "100%", marginTop: 20 }}>
                                <Button onClick={handleMarkAsDownloadTemplate} type="default" block>

                                    Mark As Complete  Download Template
                                </Button>
                                <Button className='primary-btn' type="primary" onClick={markAsCompleteExcelUpload} block>
                                    Submit
                                </Button>
                            </Space>
                        </Card>
                    </TabPane>
                </Tabs>
            </Modal>


            <Modal
                open={newSpecModel}
                onCancel={() => {
                    setNewSpecModel(false);
                    newForm.resetFields(); // Reset form when closing modal
                    setSelectedSpecId(null);
                }}
                onOk={handleReassignSpec}
                afterClose={() => {
                    setSelectedSpecId(null); // Clear selected spec when modal closes
                    newForm.resetFields(); // Reset form after modal closes
                }}
            >
                <div>
                    <p><strong>Re Assign Spec for this Box</strong></p>
                    <hr />
                    <label style={{ fontWeight: 'bold', marginBottom: 4, display: 'block' }}>Select Spec ID</label>
                    <Select
                        options={specIdData}
                        placeholder="Select Spec"
                        style={{ width: '200px' }}
                        value={selectedSpecId?.value || undefined}
                        onChange={(value) => {
                            const selected = specIdData.find((item) => item.value == value);
                            setSelectedSpecId(selected);
                        }}
                    />
                </div>
            </Modal>
            <Modal
                open={reAssignEventModal}
                onCancel={() => {
                    setReAssignEventModal(false);
                    newForm.resetFields(); // Reset form when closing modal
                    setSelectEventId(null);
                }}
                onOk={handleReworkEvents}
                afterClose={() => {
                    setSelectEventId(null); // Clear selected spec when modal closes
                    newForm.resetFields(); // Reset form after modal closes
                }}
            >
                <div>
                    <p><strong>Re Work This Box</strong></p>
                    <hr />
                    <label style={{ fontWeight: 'bold', marginBottom: 4, display: 'block' }}>Select  Event Stage</label>
                    <Select
                        options={reworkEventDataGet}
                        placeholder="Select Event Name"
                        style={{ width: '200px' }}
                        value={selectedEventId?.value || undefined}
                        onChange={(value) => {
                            const selected = reworkEventDataGet.find((item) => item.value == value);
                            setSelectEventId(selected);
                        }}
                    />
                </div>
            </Modal>


            <Modal
                title="Upload in Progress"
                open={uploadModalVisible}
                footer={[
                    <Button key="logs" type="primary" className='primary-btn' onClick={() => navigate("/job-event-log")}>
                        Go to Upload Logs
                    </Button>,
                ]}
                onCancel={() => setUploadModalVisible(false)}
            >
                <p>Data upload is in progress. Please check upload logs.</p>
            </Modal>
        </div>
    );
};

export default JobsEventsAdmin;